//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import HTTP from "@/http-common";
import PlotlyHeatmap from "@/components/PlotlyHeatmap";
import ChelTable from "@/components/ChelTable";

export default {
    components: { PlotlyHeatmap, ChelTable },
    data: function() {
        return { organisms: [], clickedIndex: null, zoomedOrganisms: [] };
    },
    methods: {
        clickCallback(eventData) {
            console.log("callback");
            console.log(eventData);
            if (eventData.points[0].data.type == "heatmap") {
                this.clickedIndex = eventData.points[0].pointIndex[0];
                this.setZoomedOrganisms();
            }
        },
        smallClickCallback(eventData) {
            console.log(eventData);
            // if (eventData.points[0].data.type == "heatmap") {
            //  this.clickedIndex = eventData.points[0].pointIndex[0];
            // }
        },
        setZoomedOrganisms() {
            this.zoomedOrganisms = this.organisms.slice(
                Math.max(0, this.clickedIndex - 3),
                Math.min(this.clickedIndex + 4, this.organisms.length)
            );
            console.log(this.zoomedOrganisms);
        },
    },

    created() {
        HTTP.get(`organisms`)
            .then((response) => {
                // JSON responses are automatically parsed.
                this.organisms = response.data;
            })
            .catch((error) => {
                console.warn(error);
            });
    },
};
